export const UpLg = () => {
	return <></>
}